import { render, staticRenderFns } from "./CustomerActivities.vue?vue&type=template&id=c2a3f19e&scoped=true&"
import script from "./CustomerActivities.vue?vue&type=script&lang=js&"
export * from "./CustomerActivities.vue?vue&type=script&lang=js&"
import style0 from "./CustomerActivities.vue?vue&type=style&index=0&id=c2a3f19e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a3f19e",
  null
  
)

export default component.exports